<svg-icon class="ui-dialog-close"
    src="/assets/icons/cross-thing.svg"
    uiDialogClose></svg-icon>

<form #settings="ngForm" (ngSubmit)="onSubmit(settings)" novalidate>
    <h3>{{ isIc() ? 'Select settings' : 'Properties' }}</h3>

    <order-settings [settings]="orderSettings" *ngIf="isIc()"></order-settings>

    <order-settings-dc (outputSettingsDc)="setOrderSettingsDc($event)"
      *ngIf="!isIc()"></order-settings-dc>

    <ui-checkbox
        name="rememberImportSettings"
        [(ngModel)]="rememberImportSettings">
        Remember these settings
    </ui-checkbox>

    <p class="ui-input-error"
        *ngIf="error"
        [ngSwitch]="error"
        [class.visible]="error">
        <span *ngSwitchDefault>{{ errorDescription }}</span>
    </p>

    <div class="actions">
        <button type="button" class="blank more" (click)="back()">Back</button>
        <button class="default start"
            type="submit"
            [disabled]="!canStartProcess(settings)">
            Start processing
        </button>
    </div>

    <ui-loading *ngIf="isLoading"></ui-loading>
</form>
